import React, { FC } from 'react';
import { NotificationListProps } from './types';
import styled from 'styled-components';
import { GridBreakpointsMediaDown, GridBreakpointsMediaUp } from '../../const/grid';

const NotificationListChild: FC<NotificationListProps> = props => {
  const { className, children } = props;
  return <div {...{ className }}>{children}</div>;
};
export const NotificationListStyled = styled(NotificationListChild)`
  // Updated width logic to make it responsive across devices - CHESPMD-628
  ${GridBreakpointsMediaDown.md} {
    width: calc(100% - 30px);
  }
  ${GridBreakpointsMediaUp.md} {
    width: 400px;
  }
  ${GridBreakpointsMediaUp.lg} {
    width: 600px;
  }
  position: fixed;
  z-index: 3000;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  & > div > div:not(:last-of-type) {
    margin: 0 0 30px;
  }
`;
